export default __webpack_public_path__ + "static/media/ParthaSarathi Mishra.df7ee139.jpg";